import { render, staticRenderFns } from "./volunteerPointQRCode.vue?vue&type=template&id=baa9cd24&scoped=true"
import script from "./volunteerPointQRCode.vue?vue&type=script&lang=js"
export * from "./volunteerPointQRCode.vue?vue&type=script&lang=js"
import style0 from "./volunteerPointQRCode.vue?vue&type=style&index=0&id=baa9cd24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa9cd24",
  null
  
)

export default component.exports